import { GrowthBook } from '@growthbook/growthbook';

import { isDevEnvironment } from '@iconik-io/core/src/is_dev_environment';

let growthbook: GrowthBook | null = null;

export function prepareGrowthBook() {
  /* cspell:disable */
  const GB_TEST_KEY = 'sdk-sqnWJr3OWXLQMOpa';
  const GB_PREVIEW_KEY = 'sdk-8EMHMaNj005Nhex0';
  const GB_PROD_KEY = 'sdk-kYPxkDwYFghccVTU';
  /* cspell:enable */

  let gbKey;
  const { host } = window.location;

  if (isDevEnvironment()) {
    if (host === 'preview.iconik.cloud') {
      gbKey = GB_PREVIEW_KEY;
    } else {
      gbKey = GB_TEST_KEY;
    }
  } else if (host.endsWith('.iconik.io')) {
    gbKey = GB_PROD_KEY;
  }

  if (gbKey) {
    growthbook = new GrowthBook({
      apiHost: 'https://cdn.growthbook.io',
      clientKey: gbKey,
      attributes: {
        host: window.location.host,
      },
    });
  }
}

export { growthbook };
